import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { abnLocaleTranslationsUrl, abnVariationQuery } from './paths';
import type { AbnTranslatedVariationResponse, AbnVariationRef } from './types';

export async function getAbnTranslatedVariation(ref: AbnVariationRef, locale: string) {
  const response = await api.executeGetRequest<ObjectResponse<AbnTranslatedVariationResponse>>(
    abnLocaleTranslationsUrl(ref, locale),
    abnVariationQuery(ref)
  );

  return response.data;
}
